module.exports = __webpack_public_path__ + "img/icon-search.9e4d57d8.svg";